import axios from 'axios';
import config from '../config/config';
import { getAuthToken } from '../utils/token';

const getAuthConfig = () => {

    const token = getAuthToken();

    return {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    };
};
/**
 * Get single Production Plan Status
 */
export const getproductionplanstatusByPO = async (po_id) => {

    return axios.post(
    `${config.API}/productiondispatchplan/getProductionPlanStatus`,
    {
        po_id
    },
    getAuthConfig()
);
};